import React from 'react'
import './index.less';
import { List, Row, Col, Image } from 'antd';

export default props => {

  const { generalInfo = {}, properArr = [] } = props;

  const itemGroups = [
    { name: 'goods_num', label: '商品数量' },
    { name: 'goods_price', label: '价格' },
    { name: 'goods_basicid', label: '平台货号' },
    { name: 'supplier_serial', label: 'ERP编码' },
    { name: 'member_num', label: '申请补货总人数' },
    { name: 'apply_num', label: '申请补货总数' },
    { name: 'no_replenish', label: '不再补货总数' },
    { name: 'replenished_num', label: '已补货总数' },
    { name: 'seckill_id', label: '秒杀id' },
    { name: 'add_time', label: '预热时间' },
    { name: 'start_time', label: '开始时间' },
    { name: 'end_time', label: '结束时间' },
    { name: 'click_total', label: '总点击量' },
    { name: 'click_b', label: 'App端当场点击量' },
    { name: 'click_c', label: 'C端当场点击量' },
  ]

  const conObj = {
    span:6,
    xs:24,
    sm:12,
    md:6
  }

  return (
    <List
      itemLayout="vertical"
      className="mb-12"
    >
      <List.Item>
        <List.Item.Meta
          avatar={<Image width={120} src={generalInfo.goods_image} />}
          title={generalInfo.goods_name}
          description={
            <Row justify="start" gutter={[4,12]}>
              {properArr.map((item, idx) => {
                const infoItem = itemGroups.find(nameItem => nameItem.name === item) || {};

                return <Col key={idx} {...conObj}>{infoItem.label}：{generalInfo[item] || ''}</Col>
              })}
            </Row>
          }
        />
      </List.Item>
    </List>
  )
}